// extracted by mini-css-extract-plugin
export default {"root":"PurchaseHistory_root__+v2t0"};